// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  userId: __t.u64().name("user_id"),
  purchaseType: __t.string().name("purchase_type"),
  stripeSessionId: __t.string().name("stripe_session_id"),
  stripePaymentIntent: __t.string().name("stripe_payment_intent"),
  amountCents: __t.i64().name("amount_cents"),
  coinsGranted: __t.i64().name("coins_granted"),
  description: __t.string(),
  status: __t.string(),
  createdAt: __t.u64().name("created_at"),
});
